export interface Integration {
  key: string
  name: string
  description: string
  logo: string
  status: 'connected' | 'pending' | 'available'
}

export const integrations: Integration[] = [
  {
    key: 'amazon',
    name: 'Amazon',
    description: 'integrations.amazon.description',
    logo: '/logos/amazon.png',
    status: 'connected'
  },
  {
    key: 'shopify',
    name: 'Shopify',
    description: 'integrations.shopify.description',
    logo: '/logos/shopify.png',
    status: 'connected'
  },
  {
    key: 'walmart',
    name: 'Walmart',
    description: 'integrations.walmart.description',
    logo: '/logos/walmart.png',
    status: 'connected'
  },
  {
    key: 'tiktok-shop',
    name: 'TikTok Shop',
    description: 'integrations.tiktokShop.description',
    logo: '/logos/tiktok-shop.png',
    status: 'connected'
  },
  {
    key: 'target',
    name: 'Target',
    description: 'integrations.target.description',
    logo: '/logos/target.png',
    status: 'connected'
  }
]